import { Box, Button, Toolbar } from '@mui/material'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'
import { Link } from 'react-router-dom'

import { AppSettingsContext } from '../../Contexts'
import { AuctionButton, EventsButton, GeotokenButton, JsonButton } from '../Components'

interface ButtonAreaProps {
  quadkey: Quadkey
}

const ButtonArea: React.FC<ButtonAreaProps> = (props) => {
  const { quadkey } = props
  const { developerMode } = useContext(AppSettingsContext)

  const ZoomOutButton: React.FC = () => {
    return (
      <Box>
        {quadkey?.toBase4HashLabel() === Quadkey.root.toBase4HashLabel() ? (
          <Button component={Link} to={'/play'} variant="outlined">
            Zoom Out
          </Button>
        ) : (
          <Button component={Link} to={`/quadkey/${quadkey?.parent()?.toBase4HashLabel()}`} variant="outlined">
            Zoom Out
          </Button>
        )}
      </Box>
    )
  }

  return (
    <Box alignItems="center" display="flex" flexDirection="row" flexGrow={1} justifyContent="space-between">
      <Box display="flex">
        <Box margin={0.5}>
          <ZoomOutButton />
        </Box>
        <Box margin={0.5}>
          <AuctionButton />
        </Box>
        <Box margin={0.5}>
          <GeotokenButton />
        </Box>
        <Box margin={0.5}>
          <EventsButton />
        </Box>
        <Box display={developerMode ? 'flex' : 'none'} margin={0.5}>
          <JsonButton />
        </Box>
      </Box>
    </Box>
  )
}

interface QuadkeyHeaderProps {
  quadkey: Quadkey
}

const QuadkeyHeader: React.FC<QuadkeyHeaderProps> = (props) => {
  const { quadkey } = props
  return (
    <Toolbar>
      <ButtonArea quadkey={quadkey} />
    </Toolbar>
  )
}

export default QuadkeyHeader
